import React from 'react';
import errorSvg from '../../assets/svg/result-error.svg';
import { useStateContext } from '../../context/StateContext';
import Card from '../../components/Card';
import style from './check-login.module.scss';

const CheckLogin = () => {
    const { state } = useStateContext();
	const { pageSettings: { checkExpiredDateDescription } } = state;
	return (
		<>
            <Card className={style.resultContainer}>
                <div className={style.checkLoginInfo}>
                    <img src={errorSvg} alt='error' />
                    <label>{checkExpiredDateDescription}</label>
                </div>
            </Card>
		</>
	);
};

export default CheckLogin;
